import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "children", "onClick"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Chip/Chip.js",
    _this = this,
    _templateObject;

import React from 'react';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import CloseIcon from './small-cross.svg';
import { testIdProps } from '../../helpers';
import { getStyledText } from '../../helpers/styled';
import Config from '../../config';

var Chip = function Chip(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledChip, _extends({
    onClick: onClick,
    clickable: Boolean(onClick),
    variant: variant
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }), typeof children === 'string' ? /*#__PURE__*/React.createElement(Chip.Text, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }, children) : children);
};

Chip.defaultProps = {
  variant: 'solid'
};
var TRANSITION_DURATION = "0.1s";
/* stylelint-disable no-descending-specificity */

var solidVariant = function solidVariant(coreTheme, clickable) {
  return css(["color:", ";border-color:", ";background:", ";svg{fill:", ";}", ";"], coreTheme.cl_white, coreTheme.cl_sec_d1, coreTheme.cl_sec_d1, coreTheme.cl_white, clickable && css(["&:hover{background:", ";border-color:transparent;}&:active{color:", ";background:", ";border-color:", ";svg{fill:", ";}}"], coreTheme.cl_sec_base, coreTheme.cl_white, coreTheme.cl_sec_d1, coreTheme.cl_sec_d1, coreTheme.cl_white));
};

var outlineVariant = function outlineVariant(coreTheme, clickable) {
  return css(["color:", ";border-color:", ";background:", ";svg{fill:", ";}", ";"], coreTheme.cl_sec_d1, coreTheme.cl_sec_d1, coreTheme.cl_white, coreTheme.cl_sec_d1, clickable && css(["&:hover{background-color:", ";}&:active{color:", ";background:", ";svg{fill:", ";}}"], coreTheme.cl_sec_l2, coreTheme.cl_white, coreTheme.cl_sec_d1, coreTheme.cl_white));
};

var clearVariant = function clearVariant(coreTheme, clickable) {
  return css(["color:", ";background:", ";svg{fill:", ";}", ";"], coreTheme.cl_sec_d1, coreTheme.cl_sec_l2, coreTheme.cl_sec_d1, clickable && css(["&:hover{background-color:", ";}&:active{color:", ";background:", ";svg{fill:", ";}}"], coreTheme.cl_sec_l1, coreTheme.cl_white, coreTheme.cl_sec_d1, coreTheme.cl_white));
};

var chipTransitionStyle = "background-color ".concat(TRANSITION_DURATION, ",\n    color ").concat(TRANSITION_DURATION, ", fill ").concat(TRANSITION_DURATION, ";");
var StyledChip = withTheme(styled.div.withConfig({
  displayName: "Chip__StyledChip",
  componentId: "sc-1idfpvk-0"
})(["box-sizing:border-box;border:1px solid transparent;display:inline-block;white-space:nowrap;", ";transition:", ";user-select:none;"], function (_ref2) {
  var variant = _ref2.variant,
      clickable = _ref2.clickable,
      coreTheme = _ref2.coreTheme;
  return css(["font-family:", ";border-radius:", "px;margin:", "px ", "px;padding:", "px ", "px;cursor:", ";", ";", ";"], coreTheme.ff_sec_bold, coreTheme.space_5, coreTheme.space_2, coreTheme.space_2, coreTheme.space_1 - 1, coreTheme.space_4 - 1, clickable ? 'pointer' : 'default', function () {
    switch (variant) {
      case 'outline':
        return outlineVariant(coreTheme, clickable);

      case 'clear':
        return clearVariant(coreTheme, clickable);

      default:
        return solidVariant(coreTheme, clickable);
    }
  }, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding: ", "px ", "px;\n      "])), coreTheme.space_1 - 1, coreTheme.space_6 - 1));
}, chipTransitionStyle));
var ChipText = getStyledText('boldBody', {
  tag: 'span',
  lineHeight: 'compact'
})(function () {
  return css(["white-space:nowrap;color:inherit;"]);
});
var ChipIconContainer = withTheme(styled.span.withConfig({
  displayName: "Chip__ChipIconContainer",
  componentId: "sc-1idfpvk-1"
})(["display:inline-block;line-height:0;position:relative;top:2px;margin:", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}"], function (p) {
  return "0 ".concat(p.coreTheme.space_2, "px");
}));
var ChipButtonContainer = styled.span.withConfig({
  displayName: "Chip__ChipButtonContainer",
  componentId: "sc-1idfpvk-2"
})(["line-height:0;display:inline-block;position:relative;padding:10px;top:0.5px;cursor:pointer;svg > path{fill:inherit;}&:first-child{margin:-5px 0 -5px -11px;}&:last-child{margin:-5px -11px -5px 0;}"]);
var ChipsContainer = styled.div.withConfig({
  displayName: "Chip__ChipsContainer",
  componentId: "sc-1idfpvk-3"
})(["margin:-8px;"]);

var ChipIcon = function ChipIcon(_ref3) {
  var Icon = _ref3.icon;
  return /*#__PURE__*/React.createElement(ChipIconContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 16,
    color: "currentColor",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 5
    }
  }));
};

var ChipCloseButton = function ChipCloseButton(props) {
  return /*#__PURE__*/React.createElement(ChipButtonContainer, _extends({}, testIdProps(props), {
    onClick: props.onClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 228,
      columnNumber: 3
    }
  }), /*#__PURE__*/React.createElement(CloseIcon, {
    viewBox: "0 0 13 12",
    width: 13,
    height: 12,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 229,
      columnNumber: 5
    }
  }));
};

Chip.Container = ChipsContainer;
Chip.Icon = ChipIcon;
Chip.CloseButton = ChipCloseButton;
Chip.Text = ChipText;
export default Chip;